import { pdfjs } from 'react-pdf';
import { isFileMetadata } from './image';

/**
 * Structural shape of the pdf.js document proxy that react-pdf hands to
 * onLoadSuccess. Covers only what we read (numPages + text extraction).
 */
export type PdfDocProxy = {
  numPages: number;
  getPage(n: number): Promise<{
    getTextContent(): Promise<{ items: Array<{ str: string } | Record<string, unknown>> }>;
  }>;
};

// Configure pdf.js worker (call once at app initialization)
export function initPdfWorker(): void {
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
}

// Check if value is a valid PDF source
export function isValidPdfSource(value: unknown): boolean {
  if (!isFileMetadata(value)) return false;
  return isValidUrl(value.url);
}

// Download PDF as blob to handle cross-origin files
export async function downloadPdf(url: string, filename: string): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(blobUrl);
}

function isValidUrl(url: string): boolean {
  return url.startsWith('http') ||
         url.startsWith('blob:') ||
         url.startsWith('data:application/pdf') ||
         url.startsWith('/');
}
